import storage from 'store';
import request from './request';
import store from '../store/index';
import {
  APP_API_BASE_URL, ADDRESS_BOOK, ADDRESS_BOOK_TIME, ACCESS_TOKEN,
} from './env';

export const fetchAddressBookListApi = (last_update_time = true) => {
  const formatDate = (time, step, format) => {
    // time 时间戳
    time = time || new Date().getTime();
    step = step || 0;
    format = format || 'yyyy-MM-dd';
    time += step * 24 * 60 * 60 * 1000;
    const date = new Date(time);
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;
    if (format === 'yyyy-MM-dd hh:mm:ss') {
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      hour = hour < 10 ? `0${hour}` : hour;
      minute = minute < 10 ? `0${minute}` : minute;
      second = second < 10 ? `0${second}` : second;
      return (
        `${year
        }-${
          month
        }-${
          day
        } ${
          hour
        }:${
          minute
        }:${
          second}`
      );
    }
    return `${year}-${month}-${day}`;
  };
  const now = formatDate(null, 0, 'yyyy-MM-dd hh:mm:ss');
  const token = store.state.user.token || storage.get(ACCESS_TOKEN);
  return request({
    url: `${APP_API_BASE_URL}user/list`,
    method: 'get',
    params: {
      last_update_time: last_update_time ? (storage.get(ADDRESS_BOOK_TIME + store.state.user.user.id + store.state.tenant.tenant) || '') : '',
    },
    headers: {
      Authorization: `Bearer ${token}`,
      tenant: store.state.tenant.tenant,
    },
    withoutHeaders: true,
    withoutToken: true,
  }).then((res) => {
    if (res.code === 0) {
      storage.set(ADDRESS_BOOK_TIME + store.state.user.user.id + store.state.tenant.tenant, now);
      storage.set(ADDRESS_BOOK + store.state.user.user.id + store.state.tenant.tenant, res.data);
    }
  });
};
